import React from "react";
import ContractDetails from "../ContractDetails";

const ContractViewDetails = ({ schemaData, contractData, snapshotData, clauseData }) => (
  <ContractDetails
    allowHistoryTooltip
    clauseData={clauseData}
    contractData={contractData}
    isCurrent
    schemaData={schemaData}
    snapshotData={snapshotData}
  />
);

export default ContractViewDetails;
